<template>
  <div class="layer-stack__body" :style="{ width: $attrs.width, height: $attrs.height }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  created() {},
  mounted() {
    // console.log(this.$slots.default);
    // console.log(this.$slots);
    // console.log(this.$slotScoped);
  },
};
</script>

<style scoped>
.layer-stack__body {
  position: relative;
  z-index: 0;
}
</style>
